
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9at9H", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $foQ4a = parcelRequire("foQ4a");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

/* RestrictedSpaceForGuest.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $lfoFx = parcelRequire("lfoFx");


var $lLRfG = parcelRequire("lLRfG");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");







var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $jmjWc = parcelRequire("jmjWc");


const $90f6c3580ed52b68$export$3925ee1231e5e137 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tijYB",
    name: "GuestRequestToUpgradeDialog",
    loader: async ()=>(await (parcelRequire("j7CxJ"))).GuestRequestToUpgradeLearnMoreModal
});



var $4ZawZ = parcelRequire("4ZawZ");

/* GuestLearnMoreLink.tsx generated by @compiled/babel-plugin v0.40.0 */ 











const $fdd4f998abed0180$var$LearnMoreLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz1kw7 _10531kw7",
            __cmplp.className
        ])
    });
});
const $fdd4f998abed0180$var$i18n = (0, $kSwu1.defineMessages)({
    learnMore: {
        id: "external-collab-ui.learn-more",
        defaultMessage: "Learn more"
    }
});
const $fdd4f998abed0180$export$f810eb001c376485 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdd4f998abed0180$var$LearnMoreLink, {
        onClick: onClick,
        href: (0, $4ZawZ.LEARN_MORE_LINK),
        target: "_blank"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $fdd4f998abed0180$var$i18n.learnMore));
};



var $gqqjz = parcelRequire("gqqjz");


var $auKqk = parcelRequire("auKqk");


var $f3euL = parcelRequire("f3euL");

var $19824710e420fbf1$exports = {};
$19824710e420fbf1$exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();


var $70faa22212588b14$exports = {};
$70faa22212588b14$exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();






var $9DHhW = parcelRequire("9DHhW");


var $eh0mb = parcelRequire("eh0mb");


var $lyF5K = parcelRequire("lyF5K");

const $89cd66f81870f5e8$export$f7109619a5e9e0d6 = 'noSpaceAccess';
const $89cd66f81870f5e8$var$UI_EVENT = 'sendUIEvent';
const $89cd66f81870f5e8$var$SCREEN_EVENT = 'sendScreenEvent';
const $89cd66f81870f5e8$var$TRACK_EVENT = 'sendTrackEvent';
const $89cd66f81870f5e8$var$CLICKED = 'clicked';
const $89cd66f81870f5e8$var$BUTTON = 'button';
const $89cd66f81870f5e8$export$1d910a789ef52c48 = ()=>{
    const [showDialog, setShowDialog] = (0, $cozmU.useState)(false);
    const [{ requestAccessState: requestAccessState }, { setRequestAccessState: setRequestAccessState }] = (0, $eh0mb.useGuestRequestUpgradeStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { upgradeStatus: upgradeStatus, upgradeStatusReason: upgradeStatusReason, loading: loading, error: error } = (0, $lyF5K.useGuestRequestToUpgradeStatus)();
    (0, $cozmU.useEffect)(()=>{
        setRequestAccessState(upgradeStatusReason === 'PENDING_REQUEST_EXISTS' ? 'submitted' : undefined);
    }, [
        upgradeStatusReason,
        setRequestAccessState
    ]);
    const toggleDialog = ()=>setShowDialog((prevState)=>!prevState);
    const fireLearnMoreClickedAnalytics = ()=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$UI_EVENT,
            data: {
                action: $89cd66f81870f5e8$var$CLICKED,
                actionSubject: $89cd66f81870f5e8$var$BUTTON,
                actionSubjectId: 'learnMoreLink',
                source: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire();
    const fireRequestAccessClickedAnalytics = ()=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$UI_EVENT,
            data: {
                action: $89cd66f81870f5e8$var$CLICKED,
                actionSubject: $89cd66f81870f5e8$var$BUTTON,
                actionSubjectId: 'requestAccess',
                source: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire();
    const fireViewScreenAnalytics = (0, $cozmU.useCallback)((canRequestUpgrade)=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$SCREEN_EVENT,
            data: {
                actionSubjectId: canRequestUpgrade ? 'guestEligibleToUpgrade' : 'guestIneligibleToUpgrade',
                name: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireOnRequestSubmittedAnalytics = (hasError)=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$TRACK_EVENT,
            data: {
                action: hasError ? 'failed' : 'requested',
                actionSubject: 'productAccess',
                source: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire();
    return {
        fireOnRequestSubmittedAnalytics: fireOnRequestSubmittedAnalytics,
        fireRequestAccessClickedAnalytics: fireRequestAccessClickedAnalytics,
        fireLearnMoreClickedAnalytics: fireLearnMoreClickedAnalytics,
        fireViewScreenAnalytics: fireViewScreenAnalytics,
        showDialog: showDialog,
        toggleDialog: toggleDialog,
        isRequestAccessPending: !!requestAccessState,
        loading: loading,
        error: error,
        canRequestUpgrade: upgradeStatus == 'CAN_REQUEST'
    };
};


const $3746f33f02cf7268$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorMessageWithRequestAccess: {
        id: "no-permission.restricted.space.guest.requestAccessMessage",
        defaultMessage: "Guest users can only access content in one space. Request licensed user access to unlock content in more spaces."
    },
    errorMessageWithoutRequestAccess: {
        id: "no-permission.restricted.space.guest.message",
        defaultMessage: "You are a guest on this Confluence site, so you can only access content in one space. {learnMoreLink}"
    },
    flagSuccessTitle: {
        id: "no-permission.restricted.space.guest.request-access.flag-success-title",
        defaultMessage: "Licensed user request sent!"
    },
    flagSuccessDescription: {
        id: "no-permission.restricted.space.guest.request-access.flag-success-description",
        defaultMessage: "If approved, you\u2019ll get a confirmation message from admin"
    },
    flagErrorTitle: {
        id: "no-permission.restricted.space.guest.request-access.flag-error-title",
        defaultMessage: "Request not sent"
    },
    flagErrorDescription: {
        id: "no-permission.restricted.space.guest.request-access.flag-error-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    },
    learnMore: {
        id: "no-permission.restricted.space.learnMore",
        defaultMessage: "Learn more about guest users"
    },
    learnMoreButton: {
        id: "no-permission.restricted.space.learnMoreButton",
        defaultMessage: "More about guest users"
    },
    requestAccessButton: {
        id: "no-permission.restricted.space.request.access.requestAccess",
        defaultMessage: "Request full access"
    },
    requestAccessPendingButton: {
        id: "no-permission.restricted.space.request.access.requestAccessPending",
        defaultMessage: "Request pending approval"
    },
    title: {
        id: "no-permission.restricted.space.guest.title",
        defaultMessage: "You don\u2019t have access to this content"
    }
});
const $3746f33f02cf7268$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_SPACE_FOR_GUEST'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3746f33f02cf7268$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _4t3i10fc",
            __cmplp.className
        ])
    });
});
const $3746f33f02cf7268$var$RestrictedSpaceForGuestComponent = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { fireOnRequestSubmittedAnalytics: fireOnRequestSubmittedAnalytics, fireLearnMoreClickedAnalytics: fireLearnMoreClickedAnalytics, fireRequestAccessClickedAnalytics: fireRequestAccessClickedAnalytics, fireViewScreenAnalytics: fireViewScreenAnalytics, canRequestUpgrade: canRequestUpgrade, showDialog: showDialog, toggleDialog: toggleDialog, isRequestAccessPending: isRequestAccessPending, loading: loading } = (0, $89cd66f81870f5e8$export$1d910a789ef52c48)();
    (0, $cozmU.useEffect)(()=>{
        if (!loading) fireViewScreenAnalytics(canRequestUpgrade);
    }, [
        loading,
        canRequestUpgrade,
        fireViewScreenAnalytics
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3746f33f02cf7268$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "restricted-space-for-guest"
    }));
    const handleError = (submissionError)=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagErrorDescription)
        });
        experienceTracker.fail({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE),
            error: submissionError
        });
    };
    const handleOnSubmit = (error)=>{
        fireOnRequestSubmittedAnalytics(!!error);
        if (!error) flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagSuccessTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagSuccessDescription)
        });
        else handleError(error);
    };
    const handlePrimaryButtonClick = ()=>{
        fireRequestAccessClickedAnalytics();
        toggleDialog();
    };
    const handleLearnMoreClick = ()=>{
        fireLearnMoreClickedAnalytics();
    };
    const errorMessage = canRequestUpgrade ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.errorMessageWithRequestAccess) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3746f33f02cf7268$export$a7357cdd1f0b0168.errorMessageWithoutRequestAccess,
        values: {
            learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdd4f998abed0180$export$f810eb001c376485), {
                onClick: handleLearnMoreClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.learnMore))
        }
    });
    const requestToUpgradeErrorPageProps = canRequestUpgrade && {
        primaryButtonProps: {
            isDisabled: isRequestAccessPending,
            onClick: handlePrimaryButtonClick,
            children: formatMessage(isRequestAccessPending ? $3746f33f02cf7268$export$a7357cdd1f0b0168.requestAccessPendingButton : $3746f33f02cf7268$export$a7357cdd1f0b0168.requestAccessButton)
        },
        secondaryButtonProps: {
            children: formatMessage($3746f33f02cf7268$export$a7357cdd1f0b0168.learnMoreButton),
            href: (0, $4ZawZ.LEARN_MORE_LINK),
            target: '_blank',
            onClick: handleLearnMoreClick
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($70faa22212588b14$exports))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($19824710e420fbf1$exports))),
        errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.title),
        errorMessage: errorMessage,
        ...requestToUpgradeErrorPageProps
    }, showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90f6c3580ed52b68$export$3925ee1231e5e137), {
        analytics: {
            touchpointId: (0, $89cd66f81870f5e8$export$f7109619a5e9e0d6)
        },
        onSubmit: handleOnSubmit,
        requestPending: isRequestAccessPending,
        closeModal: toggleDialog
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
        customData: $3746f33f02cf7268$var$CUSTOM_ATTRIBUTES
    }));
};
const $3746f33f02cf7268$export$82a38cafea37f86b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).EXTERNAL_COLLAB
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3746f33f02cf7268$var$RestrictedSpaceForGuestComponent, {
            ...props,
            flags: flags
        })));



var $fxpoI = parcelRequire("fxpoI");


























var $cLo2u = parcelRequire("cLo2u");







var $a4ade973119ca74a$exports = {};
$a4ade973119ca74a$exports = new URL("ConfluenceLogo.37570e84.svg", import.meta.url).toString();








var $c9iq1 = parcelRequire("c9iq1");

/**
 * @generated SignedSource<<82a5b792866620ec2263e953d663eee5>>
 * @relayHash e40d50d63c2471f125fb17c4d9f52651
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2691e47af9434c4f51a5b8d62ef778ce4e472319f82fb503191ebe9512b75d3
const $a05f51b93b4a489c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_resolvedSpaceKeyForContent"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e40d50d63c2471f125fb17c4d9f52651",
            "id": "e2691e47af9434c4f51a5b8d62ef778ce4e472319f82fb503191ebe9512b75d3",
            "metadata": {},
            "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
            "operationKind": "query",
            "text": "query useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery($cloudId:ID!,$id:ID!){confluence_resolvedSpaceKeyForContent(cloudId:$cloudId,id:$id)}"
        }
    };
}();
$a05f51b93b4a489c$var$node.hash = "99120215e3cab15df2137f63795c234f";
var $a05f51b93b4a489c$export$2e2bcd8739ae039 = $a05f51b93b4a489c$var$node;












var $1NBp8 = parcelRequire("1NBp8");


var $euL71 = parcelRequire("euL71");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $83Z6R = parcelRequire("83Z6R");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");

const $4ee1735caf328529$var$RESOLVED_SPACE_KEY_FOR_CONTENT_QUERY = (0, $a05f51b93b4a489c$export$2e2bcd8739ae039);
const $4ee1735caf328529$export$a0ee72f2c720a5c3 = ({ confluenceJoinability: confluenceJoinability, identityLink: identityLink, updateSpaceAccessMutation: updateSpaceAccessMutation, spaceKey: spaceKey, contentId: contentId, isRequestAccessPending: isRequestAccessPending })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition, isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const lazyResolveSpaceKey = (0, $83Z6R.useLazyQueryPromiseInterop)($4ee1735caf328529$var$RESOLVED_SPACE_KEY_FOR_CONTENT_QUERY);
    const [hasSpaceKeyResolutionFailed, setHasResolutionFailed] = (0, $cozmU.useState)(false);
    // All buttons are defined here
    const requestLicenseButtonProps = (0, $cozmU.useMemo)(()=>({
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.request.license",
                defaultMessage: "Request full access"
            }),
            href: identityLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestLicense',
                        source: 'restrictedSpaceScreen'
                    }
                }).fire();
            }
        }), [
        identityLink,
        createAnalyticsEvent
    ]);
    const goHomeButtonProps = (0, $cozmU.useMemo)(()=>({
            href: (0, $1NBp8.WIKI).toUrl(),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.space.licensed-user.request-access.go-home-button",
                defaultMessage: "Go home"
            }),
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'restrictedSpaceScreen',
                        actionSubject: 'button',
                        action: 'clicked',
                        actionSubjectId: 'goHome'
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent
    ]);
    const requestAccessButtonProps = (0, $cozmU.useMemo)(()=>{
        let buttonContent;
        if (isRequestAccessPending) buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.licensed-user.request-access.request-access-pending-button",
            defaultMessage: "Access requested"
        });
        else if ((0, $9wGTI.fg)('access-request-dialog-content-fixes')) buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.licensed-user.request-access.ask-for-access-button",
            defaultMessage: "Ask for access"
        });
        else buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.licensed-user.request-access.request-access-button",
            defaultMessage: "Request space access"
        });
        return {
            isDisabled: isRequestAccessPending || hasSpaceKeyResolutionFailed,
            children: buttonContent,
            onClick: async ()=>{
                try {
                    if (hasSpaceKeyResolutionFailed) return;
                    let resolvedSpaceKey = spaceKey ?? '';
                    if (contentId && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
                        const result = await lazyResolveSpaceKey({
                            variables: {
                                cloudId: cloudId,
                                id: contentId
                            }
                        });
                        resolvedSpaceKey = result?.confluence_resolvedSpaceKeyForContent ?? '';
                    }
                    if (updateSpaceAccessMutation) await updateSpaceAccessMutation({
                        variables: {
                            spaceKey: resolvedSpaceKey
                        }
                    });
                    else {
                        if (!resolvedSpaceKey) throw new Error(`Failed to resolve space key`);
                        else throw new Error('Unexpected error');
                    }
                } catch (e) {
                    setHasResolutionFailed(true);
                    (0, $7Sm4c.markErrorAsHandled)(e);
                }
            }
        };
    }, [
        isRequestAccessPending,
        updateSpaceAccessMutation,
        lazyResolveSpaceKey,
        cloudId,
        contentId,
        hasSpaceKeyResolutionFailed,
        spaceKey
    ]);
    const getButtonProps = (0, $cozmU.useCallback)(()=>{
        if (confluenceJoinability === 'canJoinDirectly') return {
            primary: requestLicenseButtonProps,
            secondary: goHomeButtonProps
        };
        else if (confluenceJoinability === 'licensingInProgress') return {
            primary: goHomeButtonProps
        };
        else if (!isLoggedIn || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE) // Only one button for free edition or anonymous users or unlicensed users
        return {
            primary: goHomeButtonProps
        };
        else return {
            primary: requestAccessButtonProps,
            secondary: goHomeButtonProps
        };
    }, [
        requestLicenseButtonProps,
        goHomeButtonProps,
        requestAccessButtonProps,
        confluenceJoinability,
        edition,
        isLoggedIn,
        isLicensed
    ]);
    return getButtonProps();
};


/**
 * @generated SignedSource<<0f62f1a56a40beda12036f7b38d87079>>
 * @relayHash fafd88d9e5425adee837708f24fe26e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6e5c90e051a98faf9b122bbc9ab32486b3ca5f72ce9308f9dcb08d833058b611
const $3f82aa9ae4283766$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceRequestSpaceAccessInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRequestSpaceAccessMutationRequestSpaceAccessMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceRequestSpaceAccessPayload",
                            "kind": "LinkedField",
                            "name": "requestSpaceAccess",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRequestSpaceAccessMutationRequestSpaceAccessMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceRequestSpaceAccessPayload",
                            "kind": "LinkedField",
                            "name": "requestSpaceAccess",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fafd88d9e5425adee837708f24fe26e5",
            "id": "6e5c90e051a98faf9b122bbc9ab32486b3ca5f72ce9308f9dcb08d833058b611",
            "metadata": {},
            "name": "useRequestSpaceAccessMutationRequestSpaceAccessMutation",
            "operationKind": "mutation",
            "text": "mutation useRequestSpaceAccessMutationRequestSpaceAccessMutation($spaceKey:String!){confluence{requestSpaceAccess(confluenceRequestSpaceAccessInput:{spaceKey:$spaceKey}){spaceKey,success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$3f82aa9ae4283766$var$node.hash = "b0656a69f5a88b248ff04228e7b73a8c";
var $3f82aa9ae4283766$export$2e2bcd8739ae039 = $3f82aa9ae4283766$var$node;















var $308Wd = parcelRequire("308Wd");

const $163f98496ced57cf$var$useRequestSpaceAccessMutationRequestSpaceAccessMutation = (0, $3f82aa9ae4283766$export$2e2bcd8739ae039);
const $163f98496ced57cf$export$24a5899b269a2e6 = (0, $kSwu1.defineMessages)({
    successFlagTitle: {
        id: "no-permission.restricted.space.licensed-user.request-access.success-flag.title",
        defaultMessage: "Request sent"
    },
    successFlagDescription: {
        id: "no-permission.restricted.space.licensed-user.request-access.success-flag.description",
        defaultMessage: "We\u2019ve asked the admin of the space to give you access."
    },
    generalErrorFlagTitle: {
        id: "no-permission.restricted.space.licensed-user.request-access.general-error-flag-title",
        defaultMessage: "Request not sent"
    },
    generalErrorFlagDescription: {
        id: "no-permission.restricted.space.licensed-user.request-access.general-error-flag-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    },
    spaceCreatorUnavailableErrorFlagTitle: {
        id: "no-permission.restricted.space.licensed-user.request-access.space-creator-unavailable-error-flag-title",
        defaultMessage: "Can\u2019t request access"
    },
    spaceCreatorUnavailableErrorFlagDescription: {
        id: "no-permission.restricted.space.licensed-user.request-access.space-creator-unavailable-error-flag-description",
        defaultMessage: "This space\u2019s access request functionality isn\u2019t currently available. If you need access, reach out to an admin in your organization."
    }
});
const $163f98496ced57cf$export$597cdcb8e9361db = ({ flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isRequestAccessPending, setIsRequestAccessPending] = (0, $cozmU.useState)();
    const getErrorMessage = (errorMessage, errorStatusCode)=>{
        if (errorStatusCode === 409) {
            window.location.reload();
            return null;
        } else if (errorStatusCode === 404 && errorMessage.includes('Space Creator is unavailable')) return {
            errorFlagTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.spaceCreatorUnavailableErrorFlagTitle),
            errorFlagMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.spaceCreatorUnavailableErrorFlagDescription),
            errorFlagType: 'spaceCreatorUnavailable'
        };
        return {
            errorFlagTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.generalErrorFlagTitle),
            errorFlagMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.generalErrorFlagDescription),
            errorFlagType: 'generalError'
        };
    };
    const [updateSpaceAccessMutation] = (0, $308Wd.useMutationInterop)($163f98496ced57cf$var$useRequestSpaceAccessMutationRequestSpaceAccessMutation, {
        onError: (data)=>{
            const errorStatusCode = data?.graphQLErrors[0]?.extensions?.statusCode;
            const errorMessage = data?.graphQLErrors[0]?.message;
            const errorFlagCopies = getErrorMessage(errorMessage, errorStatusCode);
            if (errorFlagCopies) {
                flags.showErrorFlag({
                    title: errorFlagCopies.errorFlagTitle,
                    description: errorFlagCopies.errorFlagMessage
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'restrictedSpaceScreen',
                        actionSubject: 'flag',
                        action: 'shown',
                        actionSubjectId: 'errorFlag',
                        attributes: {
                            errorFlagTitle: errorFlagCopies.errorFlagType
                        }
                    }
                }).fire();
            }
            setIsRequestAccessPending(false);
        },
        onCompleted: ()=>{
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.successFlagTitle),
                description: !(0, $9wGTI.fg)('access-request-dialog-content-fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.successFlagDescription) : null
            });
            setIsRequestAccessPending(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'restrictedSpaceScreen',
                    actionSubject: 'button',
                    action: 'clicked',
                    actionSubjectId: 'requestSpaceAccess'
                }
            }).fire();
        },
        __callerPackage__: "no-permission"
    });
    return {
        updateSpaceAccessMutation: updateSpaceAccessMutation,
        isRequestAccessPending: isRequestAccessPending
    };
};


const $8b25ecb55def6d32$export$358ea0c26d4a29d = ({ flags: flags, contentId: contentId, confluenceJoinability: confluenceJoinability, identityLink: identityLink })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const { isRequestAccessPending: isRequestAccessPending, updateSpaceAccessMutation: updateSpaceAccessMutation } = (0, $163f98496ced57cf$export$597cdcb8e9361db)({
        flags: flags
    });
    const { primary: primary, secondary: secondary } = (0, $4ee1735caf328529$export$a0ee72f2c720a5c3)({
        confluenceJoinability: confluenceJoinability,
        identityLink: identityLink,
        updateSpaceAccessMutation: updateSpaceAccessMutation,
        spaceKey: spaceKey,
        contentId: contentId,
        isRequestAccessPending: isRequestAccessPending
    });
    const getErrorMessages = (0, $cozmU.useCallback)(()=>{
        switch(confluenceJoinability){
            case 'canJoinDirectly':
                return {
                    errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.title.authenticated.unlicensed",
                        defaultMessage: "You need full Confluence access to view this space"
                    }),
                    errorMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.message.authenticated.unlicensed",
                        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
                        defaultMessage: "Your access to Confluence is currently limited. To view this space, you\u2019ll need submit a request for full access.    If this space is restricted, you may also need to submit request for space access."
                    }),
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($70faa22212588b14$exports))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($19824710e420fbf1$exports)))
                };
            case 'licensingInProgress':
                return {
                    errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.title.authenticated.licensing.in.progress",
                        defaultMessage: "Your Confluence access is still processing"
                    }),
                    errorMessage: null,
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($a4ade973119ca74a$exports))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($a4ade973119ca74a$exports)))
                };
            default:
                return {
                    errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.licensed-user.request-access.title",
                        defaultMessage: "You don\u2019t have access to this space"
                    }),
                    errorMessage: null,
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($70faa22212588b14$exports))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($19824710e420fbf1$exports)))
                };
        }
    }, [
        confluenceJoinability
    ]);
    const { errorTitle: errorTitle, errorMessage: errorMessage, errorImage: errorImage, errorImageDark: errorImageDark } = getErrorMessages();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: errorImage,
        errorImageDark: errorImageDark,
        errorTitle: errorTitle,
        errorMessage: errorMessage,
        primaryButtonProps: primary,
        secondaryButtonProps: secondary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9iq1.SuperAdminGateway), {
        type: "space",
        contentId: contentId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
        customData: {
            inaccessiblePageType: 'RESTRICTED_SPACE'
        }
    }));
};
const $8b25ecb55def6d32$export$53ee40f7a1d4977 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8b25ecb55def6d32$export$358ea0c26d4a29d, {
            flags: flags,
            ...props
        })));









var $jEeDd = parcelRequire("jEeDd");





var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");





var $d9tcB = parcelRequire("d9tcB");

// See here https://hello.atlassian.net/wiki/spaces/ETRUST/pages/640596761/API+Guide+-+v1+access-requests+request#Enum-Definitions
// for the enum definitions
var $21d3da76ec470ca3$var$AuthorizedCapabilities = /*#__PURE__*/ function(AuthorizedCapabilities) {
    AuthorizedCapabilities["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AuthorizedCapabilities["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AuthorizedCapabilities["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AuthorizedCapabilities["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    return AuthorizedCapabilities;
}($21d3da76ec470ca3$var$AuthorizedCapabilities || {});
// These would be the bucket of enums that we are looking for which would convey that a user's newly
// granted license hasn't synced with Confluence yet
const $21d3da76ec470ca3$var$awaitingLicenseSyncBucket = [
    "ACCESS_EXISTS",
    "ACCESS_GRANTED",
    "APPROVED_REQUEST_EXISTS"
];
const $21d3da76ec470ca3$var$getJoinability = (capability, isAuthenticatedAndUnlicensed)=>{
    if (!isAuthenticatedAndUnlicensed || capability === null) return null;
    if (capability === "DIRECT_ACCESS") return 'canJoinDirectly';
    if ($21d3da76ec470ca3$var$awaitingLicenseSyncBucket.includes(capability)) return 'licensingInProgress';
    return null;
};
const $21d3da76ec470ca3$export$839386ba3b43ffb9 = ({ skipDomainCheck: skipDomainCheck = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const [approvedCapabiity, setApprovedCapability] = (0, $cozmU.useState)(null);
    const [isDomainAccessLoading, setIsDomainAccessLoading] = (0, $cozmU.useState)(false);
    const [currentPageLink, setCurrentPageLink] = (0, $cozmU.useState)(null);
    const isAuthenticatedAndUnlicensed = accessStatus === (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const checkDirectAccessCapability = (0, $cozmU.useCallback)(async ()=>{
        const params = new URLSearchParams({
            resource: `ari:cloud:confluence::site/${cloudId}`
        });
        try {
            const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
                method: 'GET',
                headers: {
                    resource: `ari:cloud:confluence::site/${cloudId}`,
                    ACCEPT: 'application/json',
                    'Account-Id': userId || ''
                }
            });
            const data = await response.json();
            const capability = Object.values(data.results)[0];
            if (Object.values($21d3da76ec470ca3$var$AuthorizedCapabilities).includes(capability)) {
                if (capability === "DIRECT_ACCESS") createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'restrictedSpaceScreen',
                        actionSubject: 'approvedAuthenticatedUnlicensedUser',
                        action: 'identified'
                    }
                }).fire();
                setApprovedCapability(capability);
            }
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const checkDomainJoinCapability = async ()=>{
            setIsDomainAccessLoading(true);
            await checkDirectAccessCapability();
            setIsDomainAccessLoading(false);
        };
        if (isAuthenticatedAndUnlicensed && !skipDomainCheck) checkDomainJoinCapability();
    }, [
        cloudId,
        userId,
        isAuthenticatedAndUnlicensed,
        checkDirectAccessCapability,
        skipDomainCheck
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Window is not defined if this component is rendered in SSR
        if (typeof window !== 'undefined') // Identity requires an absolute URL for redirection into Confluence
        // eslint-disable-next-line no-restricted-syntax
        setCurrentPageLink(encodeURIComponent(window.location.href));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const identityLink = (0, $jEeDd.getLoginLink)((identity)=>`https://${identity}/join/user-access?resource=ari:cloud:confluence::site/${cloudId}&continue=${currentPageLink}`);
    return {
        confluenceJoinability: $21d3da76ec470ca3$var$getJoinability(approvedCapabiity, isAuthenticatedAndUnlicensed),
        identityLink: identityLink,
        isDomainAccessLoading: isDomainAccessLoading
    };
};


const $b8cff52bcf2ec9ae$export$5ef003f00c9525a1 = ({ contentId: contentId })=>{
    const { confluenceJoinability: confluenceJoinability, identityLink: identityLink, isDomainAccessLoading: isDomainAccessLoading } = (0, $21d3da76ec470ca3$export$839386ba3b43ffb9)({});
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    if (isDomainAccessLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null);
    if (isExternalCollaborator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3746f33f02cf7268$export$82a38cafea37f86b), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b25ecb55def6d32$export$53ee40f7a1d4977), {
        contentId: contentId,
        confluenceJoinability: confluenceJoinability,
        identityLink: identityLink
    }));
};
module.exports["RestrictedSpace"] = $b8cff52bcf2ec9ae$export$5ef003f00c9525a1;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $3PNw6 = parcelRequire("3PNw6");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $3PNw6.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("j7CxJ", function(module, exports) {

let $debc919c08f8d325$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $debc919c08f8d325$var$load("hhss7"),
    $debc919c08f8d325$var$load("Wowvf"),
    $debc919c08f8d325$var$load("1epse")
]).then(()=>parcelRequire('dUYlk'));

});

parcelRegister("4ZawZ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $b68f978f1accac8b$export$997e23a0aec74966 = 'https://support.atlassian.com/confluence-cloud/docs/what-can-guests-see-and-do-on-confluence/';
module.exports["LEARN_MORE_LINK"] = $b68f978f1accac8b$export$997e23a0aec74966;

});

parcelRegister("auKqk", function(module, exports) {
/* ErrorPageComponent.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $hhzGx = parcelRequire("hhzGx");


var $iNQQp = parcelRequire("iNQQp");

const $ae2504483138c997$var$ErrorContainerStyles = null;
const $ae2504483138c997$var$ErrorContainerMobileStyles = null;
const $ae2504483138c997$var$ErrorContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, resizeContainerRef: resizeContainerRef, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: resizeContainerRef,
        "data-vc": "not-found-container",
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _bfhkvuon _4t3i10fc _p12fauwl",
            isMobile && "_4t3i1kxc",
            isCenteredLayout && "_18zr1ejb _1rjc1jfw _1tke10fc _4t3i1wug _vchhusvi"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorPageWrapperStyles = null;
const $ae2504483138c997$var$ErrorPageWrapperMobileStyles = null;
const $ae2504483138c997$var$ErrorPageWrapper = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o _p12fcv93 _2lx2vrvc",
            isMobile && "_2lx21bp4",
            isCenteredLayout && "_zulp1ejb _2lx21bp4 _4cvr1h6o _1bsb1osq _p12f1fdn"
        ])
    }, children);
};
const $ae2504483138c997$var$AlignContentStyles = null;
const $ae2504483138c997$var$AlignContentMobileStyles = null;
const $ae2504483138c997$var$AlignContent = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_18s8v47k _1wpz1h6o _y3gn1e5h",
            isMobile && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
            isCenteredLayout && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1bsb1osq"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorTitleStyles = null;
const $ae2504483138c997$var$ErrorTitleMobileStyles = null;
const $ae2504483138c997$var$ErrorTitle = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_18s818rw _11c81iff _k48pi7a9 _1bsbr5sb _syazi7uo",
            isMobile && "_11c812ln _1bsb96ou",
            isCenteredLayout && "_18s812pl _11c81iff _k48pwu06 _syazi7uo _y3gn1h6o _1bsb1osq",
            isCenteredLayout && isMobile && "_11c81iff _k48pwu06 _1bsb1osq"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorMessageStyles = null;
const $ae2504483138c997$var$ErrorMessageMobileStyles = null;
const $ae2504483138c997$var$ErrorMessage = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_11c8fhey _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _k48pi7a9 _syazi7uo _p12fqxjr",
            isMobile && "_11c81d4k _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f96ou",
            isCenteredLayout && "_11c81d4k _19pkidpf _2hwx1wug _otyridpf _18u01wug _k48pi7a9 _1iqs1rm4 _syazi7uo _y3gn1h6o _p12f1fdn",
            isMobile && isCenteredLayout && "_p12f1fdn"
        ])
    }, children);
};
const $ae2504483138c997$var$ButtonContainerStyles = null;
const $ae2504483138c997$var$ButtonContainerMobileStyles = null;
const $ae2504483138c997$var$ButtonContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1e5h",
            isMobile && "_1bah1h6o",
            isCenteredLayout && "_zulppxbi _1bah1h6o _1n261g80"
        ])
    }, children);
};
const $ae2504483138c997$var$primaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250'
});
const $ae2504483138c997$var$mobilePrimaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200'
});
const $ae2504483138c997$var$secondaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250',
    marginLeft: 'space.200'
});
const $ae2504483138c997$var$mobileSecondaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200',
    marginLeft: 'space.100'
});
const $ae2504483138c997$var$childrenStyles = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$mobileChildrenStyles = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-74px`
    marginTop: '-74px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$centeredErrorContainerStyles = null;
const $ae2504483138c997$var$centeredErrorPageWrapperStyles = null;
const $ae2504483138c997$var$centeredAlignContentStyles = null;
const $ae2504483138c997$var$centeredErrorTitleStyles = null;
const $ae2504483138c997$var$centeredErrorTitleMobileStyles = null;
const $ae2504483138c997$var$centeredErrorMessageStyles = null;
const $ae2504483138c997$var$centeredErrorMessageMobileStyles = null;
const $ae2504483138c997$var$centeredButtonContainerStyles = null;
const $ae2504483138c997$var$centeredButtonStyles = (0, $buxP3.xcss)({
    marginTop: 'space.300'
});
const $ae2504483138c997$var$centeredChildrenStyles = (0, $buxP3.xcss)({
    marginTop: 'space.500',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$centeredChildrenMobileStyles = (0, $buxP3.xcss)({
    marginTop: 'space.400',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$ErrorPageChildren = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children)) return null;
    if (isCenteredLayout) {
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredChildrenMobileStyles
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredChildrenStyles
        }, children);
    }
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ae2504483138c997$var$mobileChildrenStyles
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ae2504483138c997$var$childrenStyles
    }, children);
};
const $ae2504483138c997$export$8350f8038f1a598b = ({ errorImage: errorImage, errorImageDark: errorImageDark, errorTitle: errorTitle, errorMessage: errorMessage, primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, children: children, layout: layout = 'default' })=>{
    const { resizeContainerRef: resizeContainerRef, shouldUseMobileLayout: shouldUseMobileLayout } = (0, $iNQQp.useErrorPageMobileLayout)();
    const isMobile = shouldUseMobileLayout; // CCCEMAU-2938: keep the centered layout added for Mohiti as an explicit opt-in so
    // legacy error pages continue using the existing shared layout until each consumer is
    // intentionally migrated.
    const isCenteredLayout = layout === 'centered';
    const renderPrimaryButton = ()=>{
        if (!primaryButtonProps?.children) return null;
        const button = 'href' in primaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "primary",
            ...primaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            ...primaryButtonProps
        });
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, button);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$mobilePrimaryButtonStyles
        }, button);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$primaryButtonStyles
        }, button);
    };
    const renderSecondaryButton = ()=>{
        if (!secondaryButtonProps?.children) return null;
        const button = 'href' in secondaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "default",
            ...secondaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            ...secondaryButtonProps
        });
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, button);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$mobileSecondaryButtonStyles
        }, button);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$secondaryButtonStyles
        }, button);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout,
        resizeContainerRef: resizeContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorPageWrapper, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hhzGx.ErrorPageImage), {
        src: errorImage,
        srcDark: errorImageDark,
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorTitle, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorMessage, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorMessage), (primaryButtonProps?.children || secondaryButtonProps?.children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ButtonContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, renderPrimaryButton(), renderSecondaryButton()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorPageChildren, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, children));
};
module.exports["ErrorPageComponent"] = $ae2504483138c997$export$8350f8038f1a598b;

});

parcelRegister("hhzGx", function(module, exports) {
/* ErrorPageImage.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");

const $c32ae4d4c06d56af$var$imageStylesMobile = null;
const $c32ae4d4c06d56af$var$imageStylesDesktop = null;
const $c32ae4d4c06d56af$var$centeredImageStyles = null;
const $c32ae4d4c06d56af$var$imageStyles = null;
function $c32ae4d4c06d56af$export$9afbc24a6b683cb2({ src: src, srcDark: srcDark, isMobile: isMobile, isCenteredLayout: isCenteredLayout }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: src,
        srcDark: srcDark || src,
        className: (0, $hekY6.default)([
            isCenteredLayout && "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _1bsb7rrr _p12faq80",
            !isCenteredLayout && isMobile && "_1bsb118a",
            !isCenteredLayout && !isMobile && "_1bsbn7od",
            !isCenteredLayout && "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f261p"
        ])
    });
}
module.exports["ErrorPageImage"] = $c32ae4d4c06d56af$export$9afbc24a6b683cb2;

});

parcelRegister("iNQQp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8dwdz = parcelRequire("8dwdz");

const $5359ea5c70f1dd78$export$78b0da9378bc7a2d = ()=>{
    const MOBILE_BREAKPOINT = 700;
    const [isContainerNarrow, setIsContainerNarrow] = (0, $cozmU.useState)(false);
    const lastIsNarrowRef = (0, $cozmU.useRef)(null);
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const handleResize = ([entry])=>{
        const nextIsNarrow = entry.contentRect.width < MOBILE_BREAKPOINT;
        if (lastIsNarrowRef.current !== nextIsNarrow) {
            lastIsNarrowRef.current = nextIsNarrow;
            setIsContainerNarrow(nextIsNarrow);
        }
    };
    const resizeContainerRef = (element)=>{
        // Clean up previous observer
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        // Set up new observer if element exists
        if (element) {
            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(element);
            resizeObserverRef.current = resizeObserver;
        }
    };
    // Combine existing mobile detection with container width detection
    const shouldUseMobileLayout = isContainerNarrow || (0, $8dwdz.shouldShowMobileWeb)();
    return {
        resizeContainerRef: resizeContainerRef,
        shouldUseMobileLayout: shouldUseMobileLayout
    };
};
module.exports["useErrorPageMobileLayout"] = $5359ea5c70f1dd78$export$78b0da9378bc7a2d;

});

parcelRegister("f3euL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

const $af526147f97ee327$export$dcb53e05895a448a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.INACCESSIBLE_PAGE_LOAD_KEY)
});
module.exports["INACCESSIBLE_PAGE_LOAD"] = $af526147f97ee327$export$dcb53e05895a448a;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b94r6 = parcelRequire("b94r6");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $b94r6.pageLoad,
    pageSegmentLoad: $b94r6.pageSegmentLoad,
    interaction: $b94r6.interaction,
    custom: $b94r6.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b94r6 = parcelRequire("b94r6");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b94r6.interaction) : (0, $b94r6.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b94r6", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $3L5Pu = parcelRequire("3L5Pu");


var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $01df368966019ba1$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
const $01df368966019ba1$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $01df368966019ba1$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
const $01df368966019ba1$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $01df368966019ba1$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $01df368966019ba1$export$94114666844d5f66;
module.exports["interaction"] = $01df368966019ba1$export$92473e6020ad89b4;
module.exports["custom"] = $01df368966019ba1$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $3PNw6.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("eh0mb", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4708f874261747c2$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $kBr4q.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("lyF5K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $cozmU.useState)(!skip);
    const [error, setError] = (0, $cozmU.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $cozmU.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $cozmU.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $cozmU.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("fxpoI", function(module, exports) {
/* ShowSpinnerAfterDelay.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");

const $0ee1b93a9384bc8e$export$46abe04786d4d5bb = 2000;
const $0ee1b93a9384bc8e$var$styles = {
    spinnerContainer: "_kqsw1n9t _154i1ssb _1ltv1ssb _t9ec1ooe"
};
const $0ee1b93a9384bc8e$var$i18n = (0, $kSwu1.defineMessages)({
    loadingContent: {
        id: "no-permission.loading-content",
        defaultMessage: "Loading content"
    }
});
const $0ee1b93a9384bc8e$export$bec92059adbffeba = ()=>{
    const [isTooSoonToShowSpinner, setIsTooSoonToShowSpinner] = (0, $cozmU.useState)(true);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        setTimeout(()=>{
            setIsTooSoonToShowSpinner(false);
        }, $0ee1b93a9384bc8e$export$46abe04786d4d5bb);
    }, []);
    return isTooSoonToShowSpinner ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0ee1b93a9384bc8e$var$styles.spinnerContainer,
        role: "progressbar",
        "aria-label": formatMessage($0ee1b93a9384bc8e$var$i18n.loadingContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "no-permission-loading"
    }));
};
module.exports["ShowSpinnerAfterDelay"] = $0ee1b93a9384bc8e$export$bec92059adbffeba;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("c9iq1", function(module, exports) {
/* SuperAdminGateway.js generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $euL71 = parcelRequire("euL71");


var $jmjWc = parcelRequire("jmjWc");


const $696b00ea4a51f68f$export$428a8cf25dac230d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HvSfR",
    name: "AdminKeyUpSell",
    loader: async ()=>(await (parcelRequire("kBqSh"))).AdminKeyUpSell
});






const $16cc13c688f30749$export$f265d8a86f21f5a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lp1PT",
    name: "SuperAdminEntryPoint",
    loader: async ()=>(await (parcelRequire("geZDC"))).SuperAdminEntryPoint
});



var $0g3Y7 = parcelRequire("0g3Y7");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $aJv6Q = parcelRequire("aJv6Q");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d849ce50e8d729c$var$SuperAdminEntry = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pk53f4",
            __cmplp.className
        ])
    });
});
$8d849ce50e8d729c$var$SuperAdminEntry.displayName = 'SuperAdminEntry';
const $8d849ce50e8d729c$var$SuperAdminGatewayComponent = ({ type: type, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0g3Y7.AdminKeyEligibilityQuery), null, ({ loading: loading, edition: edition, canBeSuperAdmin: canBeSuperAdmin, error: error })=>{
        if (loading || error) return null;
        if (!canBeSuperAdmin) return null;
        return edition === (0, $euL71.ConfluenceEdition).PREMIUM ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d849ce50e8d729c$var$SuperAdminEntry, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16cc13c688f30749$export$f265d8a86f21f5a8), {
            type: type,
            contentId: contentId
        })) : edition === (0, $euL71.ConfluenceEdition).FREE || edition === (0, $euL71.ConfluenceEdition).STANDARD ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d849ce50e8d729c$var$SuperAdminEntry, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $696b00ea4a51f68f$export$428a8cf25dac230d), {
            type: type
        }))) : null;
    });
};
$8d849ce50e8d729c$var$SuperAdminGatewayComponent.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'page',
        'space'
    ]).isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
const $8d849ce50e8d729c$export$55c6d178ea80c304 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
})($8d849ce50e8d729c$var$SuperAdminGatewayComponent);
module.exports["SuperAdminGateway"] = $8d849ce50e8d729c$export$55c6d178ea80c304;

});

parcelRegister("kBqSh", function(module, exports) {

let $effc1c11276b232b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $effc1c11276b232b$var$load("1GCFv"),
    $effc1c11276b232b$var$load("6XCf4"),
    $effc1c11276b232b$var$load("fINdN"),
    $effc1c11276b232b$var$load("1qlDN"),
    $effc1c11276b232b$var$load("1yVM6"),
    $effc1c11276b232b$var$load("aEiTV"),
    $effc1c11276b232b$var$load("6f3t8")
]).then(()=>parcelRequire('ie54a'));

});

parcelRegister("geZDC", function(module, exports) {

let $bd2dc426d2b42bd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd2dc426d2b42bd3$var$load("1GCFv"),
    $bd2dc426d2b42bd3$var$load("aEiTV"),
    $bd2dc426d2b42bd3$var$load("euA5f")
]).then(()=>parcelRequire('bZz8I'));

});

parcelRegister("0g3Y7", function(module, exports) {

var $47wTh = parcelRequire("47wTh");


var $6b4nE = parcelRequire("6b4nE");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

function $bb950e1e25a27f84$export$8e5be031fba9cbe5({ children: children }) {
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $47wTh.default), {
        __callerPackage__: "super-admin"
    });
    let errorToReportToChildren;
    let isUnauthorized = false;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            // If `edition` is not permitted to the current user (e.g. anonymous
            // access is not permitted), then the current user is definitely not
            // eligible for admin key. So here an unauthorized error is an expected
            // error.
            (0, $7Sm4c.markErrorAsHandled)(error);
            isUnauthorized = true;
        } else errorToReportToChildren = error;
    }
    return children({
        canBeSuperAdmin: isUnauthorized ? false : Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
        edition: isUnauthorized ? undefined : data?.confluenceTenantContext?.editions?.confluence,
        error: errorToReportToChildren,
        loading: loading
    });
}
$bb950e1e25a27f84$export$8e5be031fba9cbe5.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["AdminKeyEligibilityQuery"] = $bb950e1e25a27f84$export$8e5be031fba9cbe5;

});

parcelRegister("47wTh", function(module, exports) {
/**
 * @generated SignedSource<<362a1c55530deb6358d27bb771916187>>
 * @relayHash ddcb713faea6264b16dad4287cf3b4b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad
const $2c4160e57f9e3e3f$var$node = function() {
    var v0 = [
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        },
        {
            "alias": "confluenceTenantContext",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "ddcb713faea6264b16dad4287cf3b4b4",
            "id": "9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad",
            "metadata": {},
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "operationKind": "query",
            "text": "query AdminKeyEligibilityQueryAdminKeyEligibilityQuery{tenant{cloudId},confluenceTenantContext:confluence_tenantContext{editions{confluence}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$2c4160e57f9e3e3f$var$node.hash = "f9719ea98536123f3036cf46919010ba";
var $2c4160e57f9e3e3f$export$2e2bcd8739ae039 = $2c4160e57f9e3e3f$var$node;
module.exports["default"] = $2c4160e57f9e3e3f$export$2e2bcd8739ae039;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $bDgLe.c)(11);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $7EPz1.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});


//# sourceMappingURL=RestrictedSpace.dcffae2d.js.map
